import { customStyled } from '@mafc/trolly';

export const Label = customStyled.label(() => ({
  cursor: 'pointer',
  display: 'flex',
}));

export const RadioButton = customStyled.input`
    margin-right: 16px;
    width: 16px;
`;
